/* Przycisk koszyka na karcie punktu w sekcji "Shop the look" (8.09.2026).

   Ten sam sposob, ktorego uzywa juz `cart-recommendations.js`: `/cart/add.js`
   plus zdarzenia `cartAdded` i `cartCounterUpdate`, na ktore motyw reaguje
   odswiezeniem licznika i szuflady koszyka. Zaden wlasny mechanizm - dzieki
   temu zachowanie po dodaniu jest identyczne jak w reszcie sklepu.

   Nasluch jest jeden, na dokumencie: zestawy przelaczaja sie karuzela,
   a przy zmianie zestawu punkty sa podmieniane. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-inspiration-add]') : null;
    if (!btn) return;

    e.preventDefault();
    if (btn.classList.contains('loading')) return;

    var id = btn.dataset.variantId;
    if (!id) return;

    var source = btn.hasAttribute('data-shipping-properties') ? btn : btn.closest('product-card');
    var properties = JSON.parse(source && source.dataset.shippingProperties || '{}');

    btn.classList.add('loading');
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: properties }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (dane) {
        if (!dane.items) return;
        window.dispatchEvent(new CustomEvent('cartAdded', { detail: { added: true } }));
        window.dispatchEvent(new CustomEvent('cartCounterUpdate'));
      })
      .catch(function () { /* koszyk nie przyjal - przycisk wraca do stanu wyjsciowego */ })
      .finally(function () { btn.classList.remove('loading'); });
  });
})();
